module.exports = __webpack_public_path__ + "img/heera-icon.691719c2.webp";